import React from "react";
import { Navigate, Outlet, useLocation, useMatches } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import { Seo, SITE_NAME } from "@/components/Seo/Seo";

type ProtectedRouteProps = {
  redirectTo?: string;
};

export default function ProtectedRoute({
  redirectTo = "/login",
}: ProtectedRouteProps) {
  const matches = useMatches();
  const location = useLocation();

  const isProtected = matches.some((m) => (m as any).handle?.protected);
  const routeWantsHide = matches.some((m) => (m as any).handle?.hideSidebar);

  const hideSidebar = !isProtected || routeWantsHide;
  const isAuthed = useAuthStore((s) => s.isAuthenticated());
  const nextPath = `${location.pathname}${location.search}`;
  const authRedirect = `${redirectTo}?next=${encodeURIComponent(nextPath)}`;

  if (!isAuthed) return <Navigate to={authRedirect} replace />;

  return (
    <>
      <Seo
        title={`Личный кабинет — ${SITE_NAME}`}
        description="Личный кабинет пользователя сайта «Светлячки»."
        canonicalPath={location.pathname}
        noindex
      />
      <Outlet />
    </>
  );
}
